import React, { useEffect } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Field, formValueSelector } from 'redux-form'
import CheckboxMultipleField from 'forms/shared/fields/checkbox-multiple'
import amenitiesActions from 'actions/amenities/actions'

const SpaceAmenities = ({ categoryId, fetchCategoryAmenity, amenities }) => {
  useEffect(() => {
    categoryId && fetchCategoryAmenity(categoryId)
  }, [categoryId])

  return (
    <div className="amenities py-6">
      <p className="font-bold mb-3 text-primary-black text-xl">Space Amenities</p>
      <Field name="amenities"
        options={amenities}
        errorClassName="text-red-500 text-xs italic"
        component={CheckboxMultipleField} />
      {!categoryId && <p className="py-1 text-sm text-gray-600">Select a Space Category to get start</p>}
    </div>
  )
}

SpaceAmenities.propTypes = {
  categoryId: PropTypes.number,
  fetchCategoryAmenity: PropTypes.func,
  amenities: PropTypes.array,
}

const mapStateToProps = ({ amenities, ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    amenities: amenities.categoryAmenities,
    categoryId: selector(state, 'category_id')
  }
}

const mapDispatchToProps = {
  fetchCategoryAmenity: amenitiesActions.fetchCategoryAmenity,
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceAmenities)
